import { IForecastHorizontalDetail } from '../../interfaces/iforecast-horizontal-detail';
import { Division } from '../division';
import { ForecastHorizontal } from '../forecast-horizontal';
import { Well } from '../well';

export class ForecastHorizontalDetailBase {
  ForecastHorizontalDetailId: number;
  ForecastHorizontalId: number;
  WellId: number;
  Pdp: string;
  DaysOn: number;
  Date: Date | null;
  UnriskedOil: number;
  UnriskedGas: number;
  UnriskedWater: number;
  OilBopd: number;
  GasMcfpd: number;
  DryGasMcfpd: number;
  NglBpd: number;
  WaterBpd: number;
  Gross2StreamBoe: number;
  Gross3StreamBoe: number;
  NetOilVolumeBpd: number;
  NetWetGasVolumeMcfpd: number;
  NetDryGasVolumeMcfpd: number;
  NetNglBpd: number;
  Net2StreamBoe: number;
  Net3StreamBoe: number;
  NetJvOilVolumeBpd: number | null;
  NetJvWetGasVolumeMcfpd: number | null;
  NetJvDryGasVolumeMcfpd: number | null;
  NetJvNglBpd: number | null;
  NetJv2StreamBoe: number | null;
  NetJv3StreamBoe: number | null;
  DivisionId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Division?: Division;
  ForecastHorizontal?: ForecastHorizontal;
  Well?: Well;

  constructor(item?: IForecastHorizontalDetail) {
    if (item) {

      this.ForecastHorizontalDetailId = item.ForecastHorizontalDetailId;
      this.ForecastHorizontalId = item.ForecastHorizontalId;
      this.WellId = item.WellId;
      this.Pdp = item.Pdp;
      this.DaysOn = item.DaysOn;
      this.Date = item.Date ? new Date(item.Date) : null;
      this.UnriskedOil = item.UnriskedOil;
      this.UnriskedGas = item.UnriskedGas;
      this.UnriskedWater = item.UnriskedWater;
      this.OilBopd = item.OilBopd;
      this.GasMcfpd = item.GasMcfpd;
      this.DryGasMcfpd = item.DryGasMcfpd;
      this.NglBpd = item.NglBpd;
      this.WaterBpd = item.WaterBpd;
      this.Gross2StreamBoe = item.Gross2StreamBoe;
      this.Gross3StreamBoe = item.Gross3StreamBoe;
      this.NetOilVolumeBpd = item.NetOilVolumeBpd;
      this.NetWetGasVolumeMcfpd = item.NetWetGasVolumeMcfpd;
      this.NetDryGasVolumeMcfpd = item.NetDryGasVolumeMcfpd;
      this.NetNglBpd = item.NetNglBpd;
      this.Net2StreamBoe = item.Net2StreamBoe;
      this.Net3StreamBoe = item.Net3StreamBoe;
      this.NetJvOilVolumeBpd = item.NetJvOilVolumeBpd;
      this.NetJvWetGasVolumeMcfpd = item.NetJvWetGasVolumeMcfpd;
      this.NetJvDryGasVolumeMcfpd = item.NetJvDryGasVolumeMcfpd;
      this.NetJvNglBpd = item.NetJvNglBpd;
      this.NetJv2StreamBoe = item.NetJv2StreamBoe;
      this.NetJv3StreamBoe = item.NetJv3StreamBoe;
      this.DivisionId = item.DivisionId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Division = new Division(item.Division);
      this.ForecastHorizontal = new ForecastHorizontal(item.ForecastHorizontal);
      this.Well = new Well(item.Well);
    }
  }
}